const LOGIN  = 'LOGIN';
const LOGOUT = 'LOGOUT';
const GUARD  = 'GUARD';
const LOADING  = 'LOADING';
const USER_NOTFOUND = 'USER_NOTFOUND';

export { LOGIN, LOGOUT, GUARD, LOADING, USER_NOTFOUND };